import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RESERVED = new Set([
  "", "super", "entrar", "support", "api", "static", "assets",
  "login", "logout", "fila", "tv", "relatorios", "historico",
  "profissionais", "recepcao", "configuracoes", "personalizacao",
  "minha-vez", "meu-status",
]);
const GLOBAL_MANIFEST_BASE = "/api/manifest/global.webmanifest";

/**
 * Sincroniza <link rel="manifest"> com a rota atual durante a sessão SPA.
 *
 * A troca INICIAL (crítica para instalação PWA em iOS Safari) é feita por
 * um script inline síncrono no index.html — porque o Safari lê o manifest
 * durante o parse do <head>, antes de qualquer JS de bundle rodar.
 *
 * Este componente cobre navegações posteriores (client-side routing), para
 * que, se o usuário instalar o PWA após navegar dentro do SPA, o manifest
 * ativo no momento da instalação já reflita o tenant.
 *
 * Anexa "?v=<timestamp>" a cada troca para impedir que o Safari reuse
 * manifests cacheados no nível da origem.
 */
export default function TenantManifest() {
  const location = useLocation();

  useEffect(() => {
    try {
      const firstSeg = (location.pathname.split("/")[1] || "").toLowerCase();
      const isTenantRoute = firstSeg && !RESERVED.has(firstSeg);
      const link = document.getElementById("app-manifest") ||
        document.querySelector('link[rel="manifest"]');
      if (!link) return;
      const stamp = Date.now();
      const target = isTenantRoute
        ? `/api/tenants/${firstSeg}/manifest.webmanifest?v=${stamp}`
        : `${GLOBAL_MANIFEST_BASE}?v=${stamp}`;
      // Só troca se o path base (sem stamp) mudou — evita refetch a cada render.
      const current = (link.getAttribute("href") || "").split("?")[0];
      const targetBase = target.split("?")[0];
      if (current !== targetBase) {
        link.setAttribute("href", target);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[TenantManifest] falha ao ajustar manifest", e);
    }
  }, [location.pathname]);

  return null;
}
